// Every user-visible string, per language. French is the market's primary language (OPS-988);
// English is the toggle. {placeholders} are filled by brandStore.t(key, vars).
export const fr = {
  tagline: 'Joue. Affronte. Gagne.',
  heroTitle: 'Rejoins l’arène',
  heroText:
    'Des jeux illimités, des tournois chaque semaine et des prix à gagner avec Battle League Gaming sur MTN Cameroun.',
  trialBadge: '1er jour offert',
  plansTitle: 'Choisis ta formule',
  planDaily: 'Quotidien',
  planWeekly: 'Hebdomadaire',
  planMonthly: 'Mensuel',
  perDay: '/ jour',
  perWeek: '/ semaine',
  perMonth: '/ mois',
  mobileLabel: 'Ton numéro MTN',
  mobilePlaceholder: '6XX XXX XXX',
  mobileHint: 'Nous t’envoyons un code par SMS pour vérifier ton numéro.',
  continueCta: 'Continuer',
  subscribeCta: 'S’abonner',
  otpTitle: 'Vérifie ton numéro',
  otpText: 'Entre le code à 4 chiffres envoyé au',
  otpVerifying: 'Vérification du code…',
  otpAutoHint: 'Le code est vérifié automatiquement dès le 4e chiffre.',
  otpResend: 'Renvoyer le code',
  otpResendIn: 'Renvoyer dans {s} s',
  otpChangeNumber: 'Changer de numéro',
  otpError: 'Code incorrect. Réessaie.',
  otpSendError: 'Impossible d’envoyer le code pour le moment. Réessaie dans un instant.',
  confirmTitle: 'Confirme ton abonnement',
  confirmPlan: 'Formule',
  confirmNumber: 'Numéro',
  confirmPrice: 'Prix',
  confirmTrial: 'Gratuit pendant 24 h',
  confirmChargeFrom: 'Facturation à partir du {date} : {price} {period}, prélevé sur ton crédit MTN.',
  confirmRenewal: 'Renouvellement automatique. Résiliation à tout moment depuis le portail.',
  confirmCta: 'Confirmer l’abonnement',
  confirmConsent: 'En confirmant, tu acceptes les',
  termsConditions: 'Conditions générales',
  alreadySubscribed: 'Tu es déjà abonné(e) à Battle League Gaming.',
  portalCta: 'Accéder au portail',
  invalidNumber: 'Entre un numéro MTN Cameroun valide (ex. 67X XXX XXX).',
  subscribeError: 'Une erreur est survenue. Réessaie.',
  thankYouTitle: 'Bienvenue dans l’arène !',
  thankYouText:
    'Ton abonnement est en cours d’activation. Tu recevras un SMS de confirmation avec ton lien de connexion.',
  thankYouRedirect: 'Redirection vers le portail dans {s} s…',
  errorTitle: 'Abonnement non abouti',
  errorGeneric: 'Nous n’avons pas pu activer ton abonnement. Vérifie ton crédit MTN et réessaie.',
  evinaBlocked: 'Nous n’avons pas pu valider cette demande. Réessaie depuis ton téléphone, connecté au réseau MTN.',
  tryAgainCta: 'Réessayer',
  footerNote: 'Battle League Gaming est un service sur abonnement proposé aux clients MTN Cameroun.',
  languageLabel: 'Langue'
}

export const en = {
  tagline: 'Play. Compete. Win.',
  heroTitle: 'Enter the arena',
  heroText:
    'Unlimited games, weekly tournaments and prizes to win with Battle League Gaming on MTN Cameroon.',
  trialBadge: '1st day free',
  plansTitle: 'Choose your plan',
  planDaily: 'Daily',
  planWeekly: 'Weekly',
  planMonthly: 'Monthly',
  perDay: '/ day',
  perWeek: '/ week',
  perMonth: '/ month',
  mobileLabel: 'Your MTN number',
  mobilePlaceholder: '6XX XXX XXX',
  mobileHint: 'We will text you a code to verify your number.',
  continueCta: 'Continue',
  subscribeCta: 'Subscribe',
  otpTitle: 'Verify your number',
  otpText: 'Enter the 4-digit code sent to',
  otpVerifying: 'Checking the code…',
  otpAutoHint: 'The code is checked automatically after the 4th digit.',
  otpResend: 'Resend code',
  otpResendIn: 'Resend in {s} s',
  otpChangeNumber: 'Change number',
  otpError: 'Incorrect code. Please try again.',
  otpSendError: 'We could not send the code right now. Please try again shortly.',
  confirmTitle: 'Confirm your subscription',
  confirmPlan: 'Plan',
  confirmNumber: 'Number',
  confirmPrice: 'Price',
  confirmTrial: 'Free for 24 hours',
  confirmChargeFrom: 'Charging starts on {date}: {price} {period}, deducted from your MTN airtime.',
  confirmRenewal: 'Renews automatically. Cancel any time from the portal.',
  confirmCta: 'Confirm subscription',
  confirmConsent: 'By confirming you agree to the',
  termsConditions: 'Terms & Conditions',
  alreadySubscribed: 'You are already subscribed to Battle League Gaming.',
  portalCta: 'Open the portal',
  invalidNumber: 'Enter a valid MTN Cameroon number (e.g. 67X XXX XXX).',
  subscribeError: 'Something went wrong. Please try again.',
  thankYouTitle: 'Welcome to the arena!',
  thankYouText:
    'Your subscription is being activated. You will receive a confirmation SMS with your login link.',
  thankYouRedirect: 'Taking you to the portal in {s} s…',
  errorTitle: 'Subscription unsuccessful',
  errorGeneric: 'We could not activate your subscription. Check your MTN airtime and try again.',
  evinaBlocked: 'We could not validate this request. Please try again from your phone on the MTN network.',
  tryAgainCta: 'Try again',
  footerNote: 'Battle League Gaming is a subscription service for MTN Cameroon customers.',
  languageLabel: 'Language'
}

export default { fr, en }
